import { Accordion as AccordionPrimitive } from '@base-ui/react/accordion';
import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { cn } from '@mdvip/shared/lib/utils';

function Accordion({ className, ...props }: AccordionPrimitive.Root.Props) {
  return <AccordionPrimitive.Root data-slot="accordion" className={cn('flex flex-col', className)} {...props} />;
}

function AccordionItem({ className, ...props }: AccordionPrimitive.Item.Props) {
  return <AccordionPrimitive.Item data-slot="accordion-item" className={className} {...props} />;
}

function AccordionTrigger({
  className,
  chevronSize = 'xs',
  children,
  ...props
}: AccordionPrimitive.Trigger.Props & { chevronSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' }) {
  return (
    <AccordionPrimitive.Header className="flex">
      <AccordionPrimitive.Trigger
        data-slot="accordion-trigger"
        className={cn(
          'group flex w-full flex-1 items-center justify-between gap-4 py-4 text-left text-sm font-medium outline-none transition-[color,box-shadow] duration-fast ease-standard focus-visible:ring-2 focus-visible:ring-ring [&[data-panel-open]>i]:rotate-180',
          className,
        )}
        {...props}
      >
        <span className="min-w-0 group-hover:underline">{children}</span>
        <Icon
          name="chevronDown"
          size={chevronSize}
          className="pointer-events-none shrink-0 text-muted-foreground transition-transform duration-normal ease-standard"
        />
      </AccordionPrimitive.Trigger>
    </AccordionPrimitive.Header>
  );
}

function AccordionContent({ className, children, ...props }: AccordionPrimitive.Panel.Props) {
  return (
    <AccordionPrimitive.Panel
      data-slot="accordion-content"
      className="h-(--accordion-panel-height) overflow-hidden text-sm transition-[height] duration-normal ease-out data-ending-style:h-0 data-starting-style:h-0"
      {...props}
    >
      <div className={cn('pt-0 pb-4', className)}>{children}</div>
    </AccordionPrimitive.Panel>
  );
}

export { Accordion, AccordionContent, AccordionItem, AccordionTrigger };
